module.exports = __webpack_public_path__ + "img/logo-jood.85abadf8.png";